export default "__VITE_ASSET__B4IHhRV4__"